module.exports = __webpack_public_path__ + "img/inverse-osmosis.f9969206.svg";